import React from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { loadLessons, deleteLesson, removeFavoriteLesson } from '../../common/lessons/actions'
import { updateMe } from '../../common/users/actions'
import { LessonsList, ExerciseTestForm, PageHeader, Popup, Button } from '../components'
import { roles } from '../../common/config'

class LessonsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visibleexerciseForm: false,
    }
  }

  componentWillMount() {
    const { lessons, loadLessons, loadedLessons } = this.props
    if (!lessons.size || !loadedLessons) loadLessons()
  }

  render() {
    const { intl, viewer, updateMe } = this.props
    if (!this.props.lessons) {
      return <span>Loading...</span>
    }
    const lessons = this.props.lessons.toJS()

    const studentCreateButton = (
      <Link to="/app/create-translation">
        <Button
          id="exercise-page-create-exercise"
          big
          positive
          className="disable-spacing-right"
        >
          {intl.formatMessage(messages.createexercise)}
        </Button>
      </Link>
    )

    const teacherCreateButton = (<Button
      id="exercise-page-create-exercise"
      big
      positive
      className="disable-spacing-right"
      onClick={() => this.setState({ visibleexerciseForm: true })}
    >{intl.formatMessage(messages.createexercise)}</Button>)

    const createButton = viewer.role === roles.USER ?
      studentCreateButton
    : teacherCreateButton

    return (
      <div className="lessons-page">
        {
          (!!lessons.length && !viewer.seenGuides.exercisePage) &&
          <Popup
            text={intl.formatMessage(messages.popupGuide)}
            onClick={() => updateMe({ seenGuides: { exercisePage: true } })}
          />
        }
        <PageHeader
          title={intl.formatMessage(messages.title)}
          button={createButton}
        />
        <LessonsList lessons={lessons} showToggle isLessonsPage />
        {
          this.state.visibleexerciseForm &&
          <ExerciseTestForm
            hide={() => this.setState({ visibleexerciseForm: false })}
          />
        }
      </div>
    )
  }
}

LessonsPage.defaultProps = {
  lessons: null,
}

LessonsPage.propTypes = {
  loadLessons: PropTypes.func.isRequired,
  updateMe: PropTypes.func.isRequired,
  loadedLessons: PropTypes.bool.isRequired,
  lessons: PropTypes.object,
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    lessons: state.lessons.all,
    loadedLessons: state.lessons.loadedLessons,
  }), { updateMe, loadLessons, deleteLesson, removeFavoriteLesson }),
  injectIntl,
)

export default enhance(LessonsPage)

const messages = defineMessages({
  title: {
    id: 'lesson.page.title',
    defaultMessage: 'Cvičenia',
  },
  createexercise: {
    id: 'lesson.page.createexercise',
    defaultMessage: 'Vytvoriť cvičenie',
  },
  popupGuide: {
    id: 'lesson.page.popupGuide',
    defaultMessage: 'Na tejto stránke je zoznam Vašich cvičení. Cvičenia môžete použiť vo svojich testoch.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/LessonsPage.js